import { Injectable } from "@angular/core";
import { SMQGuestServiceBase } from "./base-classes/smq-guest-service-base";

@Injectable()
export class SMQGuestService extends SMQGuestServiceBase {

} 